// https://redux.js.org/recipes/reducing-boilerplate#generating-reducers

export const createReducer = (initialState, handlers) => {
  return function reducer(state = initialState, action) {
    const handler = action && action.type && handlers[action.type];
    if (handler) {
      return handler(state, action);
    }
    return state;
  };
};

export const makeActionCreator = (type) => {
  return function (payload) {
    return { type, payload };
  };
};
